export default __webpack_public_path__ + "static/media/alert-triangle.c17d4e4c.svg";